// billing-plugin/common/schemas/collections/discounts.js
import { z } from "zod";

/**
 * Defines a discount or coupon that can be applied to a subscription.
 */
const DiscountSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    code: z.string().describe("The user-facing coupon code, e.g., 'SUMMER20'."),
    description: z.string().optional(),
    
    discountType: z.enum(['percentage', 'fixed_amount']),
    value: z.number().positive().describe("The discount value. An integer for both types (e.g., 10 for 10%, or 500 for $5.00)."),
    
    appliesTo: z.enum(['plan_recurring_cost', 'line_item_recurring_fees', 'one_time_fees', 'all']),
    
    duration: z.enum(['once', 'forever', 'repeating']),
    durationInMonths: z.number().int().positive().nullable().optional().describe("For 'repeating' duration, how many months it applies for."),
    
    maxRedemptions: z.number().int().positive().optional().nullable().describe("Total number of times this code can be used across all users."),
    currentRedemptions: z.number().int().default(0),
    
    isActive: z.boolean().default(true),
    expiresAt: z.coerce.date().optional().nullable(),
    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default DiscountSchema;